if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"empresas","remotes":[{"alias":"@selecta","name":"selecta","entry":"/company-selecta/remoteEntry.js","shareScope":"default"},{"alias":"@panel","name":"panel","entry":"/company-panel/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(3329|3416|4444|6779|7000|846|9104)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}